import classNames from 'classnames';
import { ComponentProps } from 'react';

import GoalCardsGrid from '@components/goals/GoalCardsGrid';
import PackagesIcon from '@components/icons/PackagesIcon';
import { GoalModel } from '@models/goals';
import { GoalPackageModel } from '@models/orders';
import { setupForDark } from '@theme';

function PackagesSection({
  pkg,
  goals,
  showActions
}: {
  pkg: GoalPackageModel;
  goals: GoalModel[];
  showActions?: ComponentProps<typeof GoalCardsGrid>['showActions'];
}) {
  return (
    <div data-testid={`packages-section-${pkg.entityId}`} className='flex flex-col w-full pt-xxl'>
      <div className='flex items-center gap-xs px-sm sm:px-xxl pt-md pb-xs'>
        <PackagesIcon size={24} className={setupForDark('text-white')} />
        <span className={classNames('P3B sm:H6', setupForDark('text-white'))}>{pkg.title}</span>
      </div>
      <GoalCardsGrid goals={goals} showActions={showActions} />
    </div>
  );
}

export default PackagesSection;
